import {
	GET_CHART_COUNTER,
	GET_CHART_COUNTER_SUCCESS,
	GET_CHART_COUNTER_FAILURE,
	SET_CHART_COUNTER,
} from './types';

export const getChartCounterAction = () => ({
	type: GET_CHART_COUNTER,
});

export const getChartCounterSuccessAction = (payload: any) => ({
	type: GET_CHART_COUNTER_SUCCESS,
	payload,
});

export const getChartCounterFailureAction = (error: Error) => ({
	type: GET_CHART_COUNTER_FAILURE,
	payload: error,
});

export const setChartCounterAction = (payload: any) => ({
	type: SET_CHART_COUNTER,
	payload,
});
